export default "__VITE_ASSET__$dFdNheV__"